import Global from '../global-selectors';
import { getVisiblePackingSlips } from '../../hooks/use-visible-packing-slips';
import { PrintModalHelperService } from '../../services/print-modal-helper-service';
import { createSelector } from 'reselect';

export const selectPackingSlipTemplates = (defaultStoreTemplateOption) =>
  createSelector(
    (state) => Global.selectSellerSellerSetting(state, { settingName: 'PSFormat' }),
    getVisiblePackingSlips,
    (sellerPackingSlipFormat, sellerPackingSlips) => {
      const packingSlipsForFormat = sellerPackingSlips.filter(
        (slip) => sellerPackingSlipFormat && sellerPackingSlipFormat.includes(slip.size),
      );
      return [defaultStoreTemplateOption, ...packingSlipsForFormat];
    },
  );

export const selectSelectedPackingSlipTemplate = (templates, fulfillmentPlanIds) =>
  createSelector(
    Global.selectPrintPrintDocumentFormat,
    (state) =>
      Global.selectEntitiesFulfillmentPlanPackingSlipTemplateId(state, {
        fulfillmentPlanId: fulfillmentPlanIds[0],
      }),
    Global.selectPrintSettingsPackingSlipSettings,
    (printDocumentFormat, cswPackingSlipTemplateId, printPackingSlipFormat) => {
      return PrintModalHelperService.determinePackingSlipPrintingFormat(
        templates,
        printDocumentFormat,
        cswPackingSlipTemplateId,
        printPackingSlipFormat,
      );
    },
  );
